import { render, staticRenderFns } from "./indexHistorialAnticoncepcional.vue?vue&type=template&id=04c8c5d4"
import script from "./indexHistorialAnticoncepcional.vue?vue&type=script&lang=js"
export * from "./indexHistorialAnticoncepcional.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports